// extracted by mini-css-extract-plugin
export default {"form":"CreateProject_form__4FCJy"};